module.exports = __webpack_public_path__ + "static/KCDCdinner-5d455e59d9d5051c0828a2a9826f1194.jpg";